(function () {
    "use strict";

    angular.module("app").directive("fodbzTextRequiredMaxed", RequiredMaxedDirective);

    RequiredMaxedDirective.$inject = [];
    function RequiredMaxedDirective() {
        return {
            require: '^ngModel',
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                fodbzModel: '=',
                fodbzFieldConst: '@',                
                fodbzType: '@',
                fodbzInit: '@',
                fodbzMaxlength: '@',
                fodbzMin: '@'
            },
            controller: ['$scope', function ($scope) {
                $scope.fodbzType = angular.isDefined($scope.fodbzType) ? $scope.fodbzType : 'text';
                if ($scope.fodbzType === 'text') {
                    $scope.fodbzInit = angular.isDefined($scope.fodbzInit) ? $scope.fodbzInit : '';
                }
                else if ($scope.fodbzType === 'url') {
                    $scope.fodbzInit = angular.isDefined($scope.fodbzInit) ? $scope.fodbzInit : 'https://';
                }
                else if ($scope.fodbzType === 'number') {
                    $scope.fodbzInit = angular.isDefined($scope.fodbzInit) ? $scope.fodbzInit : '0';
                }
                else if (!angular.isDefined($scope.fodbzInit)) {
                    $scope.fodbzInit = '';
                }
            }],
            template: `
                <input aria-describedby="{{fodbzFieldConst}}"
                       class="form-control"
                       id="{{fodbzFieldConst}}"
                       name="{{fodbzFieldConst}}"
                       maxlength="{{fodbzMaxlength}}"
                       min="{{fodbzMin}}"
                       ng-model="fodbzModel"
                       ng-required="true"
                       ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }"
                       placeholder="{{fodbzInit}}"
                       type="{{fodbzType}}"
                       value=""
                       required="required">
            `
        };
    }
})();
